export const isCincelHost = (): boolean => {
  const allowedHosts = ['localhost', 'cincel.digital', 'cincel.app'];
  return allowedHosts.some((host) => window.location.hostname.endsWith(host));
};
